import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, ArrowUpRight } from 'lucide-react';
import type { ForumBase } from '../types/forum';
import { getRisingForums } from '../utils/forumGrowth';

interface Props {
  forums: ForumBase[];
  darkMode: boolean;
  title?: string;
  limit?: number;
  className?: string;
}

const RisingForumsBlock: React.FC<Props> = ({
  forums,
  darkMode,
  title = 'Bu ay yükselen forumlar',
  limit = 5,
  className = 'mb-8',
}) => {
  const rising = getRisingForums(forums, 'members', limit);
  if (rising.length === 0) return null;

  return (
    <section
      className={`rounded-xl p-4 sm:p-6 h-full ${className} ${
        darkMode ? 'bg-gray-800/80 border border-gray-700' : 'bg-white shadow-sm border border-indigo-100'
      }`}
      aria-labelledby="rising-forums-heading"
    >
      <h2
        id="rising-forums-heading"
        className={`text-lg font-semibold flex items-center gap-2 mb-4 ${
          darkMode ? 'text-white' : 'text-indigo-900'
        }`}
      >
        <TrendingUp className="text-green-500" size={22} />
        {title}
      </h2>
      <ul className="space-y-3">
        {rising.map((f, i) => (
          <li key={f.id}>
            <Link
              to={`/forum/${f.forum_id}`}
              className={`flex items-center justify-between gap-3 p-3 rounded-lg transition-colors ${
                darkMode ? 'hover:bg-gray-700' : 'hover:bg-indigo-50'
              }`}
            >
              <span className="flex items-center gap-3 min-w-0">
                <span
                  className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold ${
                    darkMode ? 'bg-indigo-900 text-indigo-300' : 'bg-indigo-100 text-indigo-700'
                  }`}
                >
                  {i + 1}
                </span>
                <span className="font-medium truncate">{f.name}</span>
              </span>
              <span className="flex items-center gap-1 text-green-500 text-sm font-medium shrink-0">
                <ArrowUpRight size={14} />
                +{f.growthPercent.toFixed(1)}% üye
              </span>
            </Link>
          </li>
        ))}
      </ul>
      <Link
        to="/rising"
        className={`inline-block mt-4 text-sm ${darkMode ? 'text-indigo-400' : 'text-indigo-600'} hover:underline`}
      >
        Tüm yükselenleri gör →
      </Link>
    </section>
  );
};

export default RisingForumsBlock;
